import moment from "moment";

export default {
  type: "establishment-transfers",
  code: null,
  name: "",
  transfer_date: moment().format("YYYY-MM-DD"),
  status: "DRAFT",
  excerpt: "",
  relationshipNames: [
    "organization",
    "serviceCenter",
    "sourceEstablishment",
    "destinationEstablishment",
    "items",
  ],
  organization: {
    type: "organizations",
    id: null,
  },
  sourceEstablishment: {
    type: "establishments",
    id: null,
  },
  destinationEstablishment: {
    type: "establishments",
    id: null,
  },
  items: [],
};
